import type { DisplayTokens } from './types';

export const display: DisplayTokens = {
  letterSpacings: {
    1: 'condensed',
    2: 'condensed',
    3: 'condensed',
  },
};
